webpackJsonp([60831877734937],{

/***/ 2095:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"VitalsTemplate","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"field","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-vitals-template-6bab8cfe635ee80d23b9.js